import { useEffect, useState, useMemo } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { useUserStore } from 'store';
import Icon from 'components/Icon';
import Text from 'components/Text';
import { TEXT_STRING } from '../../../constants';
import { TGlamourImage } from 'types';

type Props = {
  images: TGlamourImage[];
};

function GlamourImage({ images = [] }: Props) {
  const [currentIdx, setCurrentIdx] = useState(0);
  const { isAuthenticated } = useUserStore();

  const processedImages = useMemo(() => {
    const mainImage = images.find((img) => img.isMain);
    const otherImages = images.filter((img) => !img.isMain);

    const allImages = mainImage ? [mainImage, ...otherImages] : otherImages;

    return allImages.map((image, idx) => ({
      ...image,
      idx,
    }));
  }, [images]);

  useEffect(() => {
    setCurrentIdx(0);
  }, [images]);

  return (
    <div className="mt-22px">
      <Carousel
        selectedItem={currentIdx}
        onChange={setCurrentIdx}
        showArrows={false}
        showStatus={false}
        infiniteLoop={true}
        emulateTouch={true}
        dynamicHeight={true}
        renderThumbs={() =>
          processedImages.map((img, idx) => (
            <img
              src={img.imageUrl}
              className="object-cover object-top aspect-square"
              height={100}
              alt=""
            />
          ))
        }
      >
        {processedImages.map((image) => (
          <div key={`slide-${image.idx}`} className="relative">
            <img
              src={image.imageUrl}
              loading="lazy"
              className="object-contain object-center"
              alt=""
            />
            {!isAuthenticated && (
              <div className="absolute z-[1] inset-0 flex flex-col gap-2 justify-center items-center w-full h-full">
                <Icon icon="lock" />
                <Text
                  textColor="text-white"
                  fontSize={14}
                  className="w-1/2"
                  center
                >
                  {TEXT_STRING.CAST_PAGE.REQUIRE_LOGIN_FOR_GLAMOUR_IMAGE}
                </Text>
              </div>
            )}
          </div>
        ))}
      </Carousel>
    </div>
  );
}

export default GlamourImage;
